import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import Sidebar from './Sidebar';

export default function Layout({ children, user, onLogout, isEmployee, permissions, employeeInfo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-obsidian">
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-obsidian/95 backdrop-blur-md border-b border-glass-border px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h1 className="font-heading text-xl font-bold text-neon-blue">DJ CRM</h1>
        </div>
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="p-2 rounded-lg hover:bg-white/10 transition-colors"
          data-testid="mobile-menu-toggle"
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {mobileMenuOpen ? (
            <X className="w-6 h-6 text-foreground" />
          ) : (
            <Menu className="w-6 h-6 text-foreground" />
          )}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div 
          className="lg:hidden fixed inset-0 z-50 bg-black/60 backdrop-blur-sm"
          onClick={() => setMobileMenuOpen(false)}
          data-testid="mobile-menu-overlay"
        >
          <div 
            className="relative w-72 max-w-[85vw] h-full animate-in slide-in-from-left duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button - positioned at top right of sidebar */}
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="absolute top-4 right-2 z-[60] p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors"
              data-testid="mobile-menu-close"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
            <Sidebar 
              user={user} 
              onLogout={onLogout} 
              isEmployee={isEmployee} 
              permissions={permissions} 
              employeeInfo={employeeInfo}
              onNavigate={() => setMobileMenuOpen(false)}
            />
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div className="hidden lg:block flex-shrink-0">
        <Sidebar 
          user={user} 
          onLogout={onLogout} 
          isEmployee={isEmployee} 
          permissions={permissions} 
          employeeInfo={employeeInfo} 
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto pt-14 lg:pt-0">
        {children}
      </div>
    </div>
  );
}
